import LeftMenuConst from './../LeftSideBar/const';

const Const = {
    [LeftMenuConst.LEFT_SIDE_BAR_MOBILE_IS_ACTIVE]: LeftMenuConst.LEFT_SIDE_BAR_MOBILE_IS_ACTIVE
};

export default Const;